import { createAction } from '@reduxjs/toolkit';

export const openDrawer = createAction<string>('drawer/open');
export const closeDrawer = createAction('drawer/close');
